import { render } from "./Dashbord.vue?vue&type=template&id=4c03ad94&scoped=true"
import script from "./Dashbord.vue?vue&type=script&lang=js"
export * from "./Dashbord.vue?vue&type=script&lang=js"

import "./Dashbord.vue?vue&type=style&index=0&id=4c03ad94&lang=css"
import "./Dashbord.vue?vue&type=style&index=1&id=4c03ad94&lang=css"
import "./Dashbord.vue?vue&type=style&index=2&id=4c03ad94&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c03ad94"]])

export default __exports__